export const llSystemSupportCardBrands = [
  'AMEX',
  'DINERSCLUB',
  'DISCOVER',
  'JCB',
  'MASTERCARD',
  'VISA',
  'UNIONPAY',
];

// 订阅模式支持的卡组
export const SUBSCRIPTION_ALLOWED_CARD_BRANDS = ['visa', 'mastercard'];



